<h2>Portal Roles</h2>

<div class="grid">
    <div class="col-5">
        <div class="col-1">
            <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($any($event))"></p-button>
            <!-- <button pButton type="button" label="Search" class="ui-button-success" (click)="onSearchClick($any($event))"></button> -->
        </div>  
    </div>
    <!-- <h3 [hidden]="hideRole">
        Role Details: {{selectedRole}}
    </h3> -->
</div>

<!-- L I S T   O F   R O L E S -->    

<div class="grid">
    <div class="col-6">

        <p-table #dt [columns]="roleCols" [value]="roles" selectionMode="single" [(selection)]="selectedRole"
            class="wal-table p-datatable-striped" 
            sortMode="multiple" (onRowSelect)="onRoleRowSelect($event)" [paginator]="true" [rows]="15" >
          <ng-template pTemplate="caption">
              List of Roles
          </ng-template>
          <ng-template pTemplate="header" let-columns>
              <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
            </tr>
              <tr>

                @for (col of columns; track col.field) {
                    <th [style.width]="col.width">
                        @switch (col.field) {
                            @case ('roleName') {
                                <input pInputText type="text" [style.width]="'100%'"
                                    (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    
                                />
                            }
                            @case ('enabled') {
                                <input pInputText type="text" [style.width]="'100%'"
                                    (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                />
                            }
                            @default {
                            }
                        }
                    </th>
                }

            </tr>  
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
              </tr>
          </ng-template>
          <ng-template pTemplate="summary" let-rowData>
              <div style="text-align:left" *ngIf="isSubmitShown">
                  <!-- <button type="button" pButton icon="fa fa-plus p-button-raised p-button-rounded" (click)="addRole()" label="Add"></button> -->
                  <p-button label="Add" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="addRole()"></p-button>
              </div>
          </ng-template>    
        </p-table> 
      
    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body"></p-confirmDialog>

    <!-- F U L L   V I E W   OF   O N E   R O L E -->    

    <p-dialog appendTo="body" header="Details for Role: {{role.roleName}}" [(visible)]="displayDialog" 
        [focusOnShow]="false" [responsive]="true" styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '50%'}">

    <div *ngIf="role">

        <p-tabs class="wal-tabs" [(value)]="tabIndex">

          <p-tablist>

            <p-tab [value]="'Role Attributes'">
              <span class="tab-label">
                <i class="pi pi-user-edit" aria-hidden="true"></i>
                <span class="ml-2">Role Attributes</span>
              </span>
            </p-tab>

            <p-tab [value]="'Role Privileges'">
              <span class="tab-label">
                <i class="pi pi-check-circle" aria-hidden="true"></i>
                <span class="ml-2">Role Privileges</span>
              </span>
            </p-tab>

            <p-tab [value]="'Users'">
              <span class="tab-label">
                <i class="pi pi-sitemap" aria-hidden="true"></i>
                <span class="ml-2">Users</span>
              </span>
            </p-tab>

          </p-tablist>  

          <p-tabpanels>

            <p-tabpanel [value]="'Role Attributes'">

                <p-card header="Role Attributes" subheader="" styleClass="ui-card-light">
        
                    <div class="grid">
                        <div class="col-10">

                            <div class="field grid">
                                <label for="roleId" class="col-fixed label" style="width:15em">Role Id:</label>
                                <div class="col">
                                    <input pInputText id="roleId" type="text" [(ngModel)]="role.roleId" style="width: 20%;"  
                                    placeholder="Required" [readonly]="true"/> 
                                </div>
                              </div>                               

                              <div class="field grid">
                                <label for="roleName" class="col-fixed label" style="width:15em">Role Name:</label>
                                <div class="col">
                                    <input pInputText id="roleName" type="text" [(ngModel)]="role.roleName" style="width: 50%;"  
                                    placeholder="roleName"/> 
                                </div>
                              </div>                               

                              <div class="field grid">
                                <label for="roleDescription" class="col-fixed label" style="width:15em">Role Description:</label>
                                <div class="col">
                                    <input pInputText id="roleDescription" type="text" [(ngModel)]="role.roleDescription" style="width: 100%;"  
                                    placeholder="roleDescription"/> 
                                </div>
                              </div>                               

                              <div class="field grid">
                                <label for="enabled" class="col-fixed label" style="width:15em">Enabled?:</label>
                                <div class="col">
                                    <p-checkbox [(ngModel)]="role.enabled" id="enabled" [binary]="true" [readonly]="false"></p-checkbox>
                                </div>
                              </div>                               

                              <div class="field grid">
                                <label for="createDate" class="col-fixed label" style="width:15em">Create Date:</label>
                                <div class="col">
                                    <input pInputText id="createDate" type="text" [(ngModel)]="role.createDate" style="width: 50%;"  
                                    placeholder="createDate" [readonly]="true"/> 
                                </div>
                              </div>                               

                              <div class="field grid">
                                <label for="lastUpdateDate" class="col-fixed label" style="width:15em">Last Update Date:</label>
                                <div class="col">
                                    <input pInputText id="lastUpdateDate" type="text" [(ngModel)]="role.lastUpdateDate" style="width: 50%;"  
                                    placeholder="lastUpdateDate" [readonly]="true"/> 
                                </div>
                              </div>                               

                        </div>                        
        
                    </div>
            
                    <p-footer>
                        <mat-icon class="nav-caption wal-center">add_a_photo</mat-icon>
                    </p-footer>
                </p-card>

            </p-tabpanel>

            <p-tabpanel [value]="'Role Privileges'">

                <p-pickList [source]="availablePrivileges" [target]="grantedPrivileges" 
                        sourceHeader="Available" targetHeader="Granted" class="wal-picklist"
                        [sourceStyle]="{height:'25rem'}" [targetStyle]="{height:'25rem'}" 
                        styleClass="ui-card-light" filterBy="tags"
                        [responsive]="true" [dragdrop]="true" [showSourceControls]="false" [showTargetControls]="false">
                    <ng-template let-privilege pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <div>{{ privilege.privilegeName }}</div>
                        </div>
                    </ng-template>
                </p-pickList>

            </p-tabpanel>

            <p-tabpanel [value]="'Users'">

                <p-table #dt [columns]="userCols" [value]="roleUsers" selectionMode="single"  
                    class="wal-table p-datatable-striped"
                    sortMode="multiple"  [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15,25,50,75]">
                    <ng-template pTemplate="caption">
                        List of Users with the Role Granted
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            @for (col of columns; track col.field) {
                                <th [pSortableColumn]="col.field"
                                    [style.display]="col.display"
                                    [style.width]="col.width">
                                    {{ col.header }}
                                    <p-sortIcon [field]="col.field"></p-sortIcon>
                                </th>
                            }
                        </tr>
                        <tr>

                            @for (col of columns; track col.field) {
                                <th [style.width]="col.width">
                                    @switch (col.field) {
                                        @case ('emailAddress') {
                                            <input pInputText type="text" [style.width]="'100%'"
                                                (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                                
                                            />
                                        }
                                        @case ('userName') {
                                            <input pInputText type="text" [style.width]="'100%'"
                                                (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                            />
                                        }
                                        @default {
                                        }
                                    }
                                </th>
                            }


                        </tr>  
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            @for (col of columns; track col.field) {
                                <td [style.width]="col.width" [style.display]="col.display">
                                    {{ rowData[col.field] }}
                                </td>
                            }
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary" let-rowData>
                    </ng-template>    
                </p-table> 

            </p-tabpanel>

          </p-tabpanels>        

        </p-tabs>

    </div>

    <ng-template #footer>
        <div class="footer-actions">
            <p-button label="Delete" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="deleteRole()" *ngIf="isSubmitShown"></p-button>
            <p-button label="Save" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSaveRoleClick()" *ngIf="isSubmitShown"></p-button>
            <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancel()"></p-button>
        </div>
    </ng-template>

</p-dialog>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="portal-role"></p-confirmDialog>


